export const Drop_ITEM = {
  TOOL: 'TOOL'
};

export const EDITOR_TYPE = {
  TEXT: 'text',
  SINGLE_CHOICE: 'singleChoice'
};